const DEFAULT_LOAD_TYPE_IDS = ['EPAL_1'];
export const DEFAULT_SUPPORTED_LOAD_TYPE_IDS = DEFAULT_LOAD_TYPE_IDS; // used on area level
export const DEFAULT_ENABLED_LOAD_TYPE_IDS = DEFAULT_LOAD_TYPE_IDS; // used on floorplan level
